import { RibbonGroupBase } from '../ribbon-interfaces';
import { createElement, Browser, EventHandler } from '@syncfusion/ej2-base';
export const IMAGE_LOCAL_ID = '_image_local';
/**
 * Illustrations group implementation for Insert tab
 * @private
 */
export class IllustrationsGroup extends RibbonGroupBase {
    /**
     * Constructor for IllustrationsGroup
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    constructor(container) {
        super(container);
        // Create image picker for file upload
        this.imagePicker = createElement('input', {
            attrs: { type: 'file', accept: '.jpg,.jpeg,.png,.bmp,.svg' },
            className: 'e-de-ctnr-file-picker'
        });
        if (Browser.isIE) {
            document.body.appendChild(this.imagePicker);
        }
        // Add event handler for image selection
        EventHandler.add(this.imagePicker, 'change', this.onImageChange, this);
    }
    /**
     * Get the Ribbon items for Illustrations group
     * @returns {RibbonGroupModel} - Ribbon group model for Illustrations group
     * @private
     */
    getGroupModel() {
        return {
            header: this.localObj.getConstant('Illustrations'),
            groupIconCss: 'e-icons e-de-ctnr-image',
            keyTip: 'P',
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Illustrations'),
            collections: [{
                    items: [{
                            type: 'DropDown',
                            keyTip: 'U',
                            dropDownSettings: {
                                content: this.localObj.getConstant('Image'),
                                iconCss: 'e-icons e-de-ctnr-image',
                                items: [
                                    {
                                        text: this.localObj.getConstant('Upload from computer'),
                                        id: this.ribbonId + IMAGE_LOCAL_ID,
                                        iconCss: 'e-icons e-de-ctnr-upload'
                                    }
                                ],
                                select: this.onImageDropDownSelect.bind(this)
                            },
                            id: this.ribbonId + '_image',
                            ribbonTooltipSettings: {
                                content: this.localObj.getConstant('Insert inline picture from a file')
                            }
                        }]
                }]
        };
    }
    onImageDropDownSelect(args) {
        const id = args.item.id;
        if (id === this.ribbonId + IMAGE_LOCAL_ID) {
            this.imageClickHandler();
        }
    }
    imageClickHandler() {
        this.imagePicker.value = '';
        this.imagePicker.click();
    }
    onImageChange() {
        const file = this.imagePicker.files[0];
        if (!file) {
            return;
        }
        const fileReader = new FileReader();
        fileReader.onload = () => {
            this.insertImage(fileReader.result);
        };
        fileReader.readAsDataURL(file);
    }
    insertImage(data) {
        const image = document.createElement('img');
        const container = this.container;
        image.addEventListener('load', function () {
            container.documentEditor.editorModule.insertImageInternal(data, true, this.width, this.height, this.alt);
        });
        image.src = data;
    }
    /**
     * Clean up resources
     * @returns {void}
     */
    destroy() {
        // Remove event listeners
        if (this.imagePicker) {
            EventHandler.remove(this.imagePicker, 'change', this.onImageChange);
            // Clean up DOM elements
            if (this.imagePicker.parentElement) {
                this.imagePicker.parentElement.removeChild(this.imagePicker);
            }
            this.imagePicker = undefined;
        }
        // Clear all references
        this.container = undefined;
        this.localObj = undefined;
    }
}
